"use strict";
var hlp = require('common/helpers');
var TYPE_DIVIDER = '#';
var ATTR_DIVIDER = '$';
var ENTRY_DIVIDER = ';';
var LINK_DIVIDER = '-';
var FIELD_DIVIDER = '_';
var COMMENT_DIVIDER = '+';
var REMARKABLE_DIVIDER = '!';
var QUESTIONABLE_DIVIDER = '?';
var LINK_REGEX = new RegExp("^([eE][1-9][0-9]*)?\\" + LINK_DIVIDER + "([eE]?[1-9][0-9]*)$");
var LINK_TYPE_REGEX = /^[\w\u0030-\u0039\u002D\u0041-\u007F\u0080-\u00FF\u0100-\u017F\u0180-\u024F]+$/;
var ENTITY_REGEX = /^[eE][1-9][0-9]*$/;
var ENTITY_OR_PARENT_REGEX = /^(?:[eE][1-9][0-9]*)|([<]+)$/;
var ENTITY_TYPE_REGEX = /^[a-zA-Z]{1,2}$/;
var parse = function(cmd) {
  var splitted = cmd.split(TYPE_DIVIDER);
  if (splitted.length > 4) {
    return {
      message: "Syntax error",
      ok: false
    };
  }
  if (splitted[0].match(LINK_REGEX))
    return parseLinkCmd(splitted);
  else
    return parseEntityCmd(splitted);
};
var parseLinkCmd = function(splitted) {
  if (splitted.length > 2)
    return {
      ok: false,
      message: "Ungültige Syntax für Verbindung",
      type: 'error'
    };
  if (splitted.length == 2 && !splitted[1].match(LINK_TYPE_REGEX))
    return {
      ok: false,
      message: "Link-Typ ungültig",
      type: 'error'
    };
  var matches = splitted[0].match(LINK_REGEX);
  var relation_type = splitted.length == 2 ? splitted[1] : null;
  var entity1 = matches[1];
  var entity2 = matches[2];
  if (entity2[0] != 'e' && entity2[0] != 'E')
    entity2 = 'E' + entity2;
  return {
    type: 'relations',
    ok: true,
    entity1: entity1,
    entity2: entity2,
    relation_type: relation_type
  };
};
var parseEntityCmd = function(splitted) {
  var entity = null;
  var entityType = null;
  var relation_type = null;
  if (splitted.lenght == 2 && !splitted[0])
    splitted.shift();
  while (splitted.length > 1) {
    if (splitted.length == 4 && !splitted[0].match(ENTITY_OR_PARENT_REGEX))
      return {
        ok: false,
        message: "Ungültige Syntax für Entität: '" + splitted[0] + "'",
        type: 'error'
      };
    else if (splitted[0].match(ENTITY_OR_PARENT_REGEX) && entity == null)
      entity = splitted.shift();
    else if (splitted[0].match(ENTITY_TYPE_REGEX) && entityType == null)
      entityType = splitted.shift();
    else if (splitted[0].match(LINK_TYPE_REGEX) && relation_type == null && entityType != null)
      relation_type = splitted.shift();
    else
      return {
        ok: false,
        message: "Konnte Eingabe '" + splitted[0] + "' nicht zuordnen",
        type: 'error'
      };
  }
  var fieldString = splitted.shift();
  var fields = parseFields(fieldString);
  if (typeof(fields) == 'string')
    return {
      type: 'error',
      ok: false,
      message: fields
    };
  return {
    type: 'entity',
    ok: true,
    entity: entity,
    entity_type: entityType,
    relation_type: relation_type,
    fields: fields
  };
};
var ENTRY_REGEX = new RegExp('^(?:(?:)|(?:([^' + '\\' + COMMENT_DIVIDER + '\\' + FIELD_DIVIDER + '\\' + ENTRY_DIVIDER + ']*' + '[^' + '\\' + COMMENT_DIVIDER + '\\' + FIELD_DIVIDER + '\\' + ENTRY_DIVIDER + '\\?\\!]' + ')' + '(\\?\\!|\\!\\?|\\!|\\?)?' + '(?:\\' + COMMENT_DIVIDER + '([^' + FIELD_DIVIDER + ENTRY_DIVIDER + TYPE_DIVIDER + ']*))?))$');
var parseFields = function(fieldStr) {
  var singleFields = fieldStr.split(FIELD_DIVIDER);
  var result = [];
  for (var i = 0; i < singleFields.length; ++i) {
    var fieldString = singleFields[i];
    var entries = fieldString.split(ENTRY_DIVIDER);
    var field = [];
    for (var j = 0; j < entries.length; ++j) {
      var entryString = entries[j];
      var match = entryString.match(ENTRY_REGEX);
      if (!match)
        return "Ungültiger Wert-Eintrag '" + entryString + "'";
      field.push({
        value: match[1],
        flags: match[2] ? match[2] : null,
        comments: match[3] ? match[3] : null
      });
    }
    result.push(field);
  }
  return result;
};
parse.description = {dividers: {
    type_divider: TYPE_DIVIDER,
    attr_divider: ATTR_DIVIDER,
    entry_divider: ENTRY_DIVIDER,
    link_divider: LINK_DIVIDER,
    field_divider: FIELD_DIVIDER,
    comment_divider: COMMENT_DIVIDER,
    remarkable_divider: REMARKABLE_DIVIDER,
    questionable_divider: QUESTIONABLE_DIVIDER
  }};
module.exports = parse;
